import { InfoModalForm } from "./InfoModalForm"


const InfoModalFormWrapper = () => {
    return (<InfoModalForm />)
}

export {InfoModalFormWrapper}